{
  "COMPOSE_REDIRECT": {
    "OPENING": "Pradedamas naujas pokalbis su {email}…",
    "NO_EMAIL": "Nenurodytas el. pašto adresas. Naudokite ?email=name@example.com",
    "CONTACT_ERROR": "Nepavyko rasti kontakto pagal {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Kairiojoje srityje pasirinkite pokalbį",
    "CSAT_REPLY_MESSAGE": "Prašome įvertinti pokalbį",
    "404": "Atsiprašome, negalime rasti pokalbio. Prašau, pabandykite dar kartą",
    "SWITCH_VIEW_LAYOUT": "Perjunkite išdėstymą",
    "DASHBOARD_APP_TAB_MESSAGES": "Pranešimai",
    "UNVERIFIED_SESSION": "Šio vartotojo tapatybė nepatvirtinta",
    "NO_MESSAGE_1": "Oi! Panašu, kad jūsų gautų laiškų aplanke nėra pranešimų iš klientų.",
    "NO_MESSAGE_2": " norėdami išsiųsti žinutę į savo puslapį!",
    "NO_INBOX_1": "Sveiki! Panašu, kad dar nepridėjote jokių gautųjų laiškų aplanko.",
    "NO_INBOX_2": " norint pradėti",
    "NO_INBOX_AGENT": "Oi! Atrodo, kad nesate jokio gautų laiškų aplanko dalis. Susisiekite su administratoriumi",
    "SEARCH_MESSAGES": "Ieškokite pranešimų pokalbiuose",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Vertimas",
    "EMPTY_STATE": {
      "CMD_BAR": "norėdami atidaryti komandų meniu",
      "KEYBOARD_SHORTCUTS": "norėdami peržiūrėti sparčiuosius klavišus"
    },
    "SEARCH": {
      "TITLE": "Ieškoti pranešimų",
      "RESULT_TITLE": "Rezultatų Paieška",
      "LOADING_MESSAGE": "Duomenys apdorojami...",
      "PLACEHOLDER": "Parašykite tekstą pranešimų paieškai",
      "NO_MATCHING_RESULTS": "Nieko nerasta."
    },
    "UNREAD_MESSAGES": "Neperskaitytos žinutės",
    "UNREAD_MESSAGE": "Neperskaityta žinutė",
    "CLICK_HERE": "Paspausti čia",
    "LOADING_INBOXES": "Įkeliami gautų laiškų aplankai",
    "LOADING_CONVERSATIONS": "Pokalbiai parsiunčiami",
    "CANNOT_REPLY": "Jūs negalite atsakyti dėl",
    "24_HOURS_WINDOW": "Pranešimų apribojimas 24 valandoms",
    "NOT_ASSIGNED_TO_YOU": "Šis pokalbis jums nepriskirtas. Ar norėtumėte priskirti šį pokalbį sau?",
    "ASSIGN_TO_ME": "Priskirti man",
    "TWILIO_WHATSAPP_CAN_REPLY": "Į šį pokalbį galite atsakyti tik naudodami šablono pranešimą, nes",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Pranešimų apribojimas 24 valandoms",
    "REPLYING_TO": "Jūs atsakote į:",
    "REMOVE_SELECTION": "Pašalinti Pasirinkimą",
    "DOWNLOAD": "Parsisiųsti",
    "UNKNOWN_FILE_TYPE": "Nežinomas failas",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Prieš siunčiant atlikite:",
      "EXECUTE": "Atlikti",
      "RETRY": "Bandyti dar kartą",
      "CONFIRM": "Atlikti dabar?",
      "CONFIRM_YES": "Taip, atlikti",
      "CONFIRM_NO": "Atšaukti",
      "RUNNING": "Vykdoma…",
      "DONE": "Atlikta",
      "CLAIM_DELAYED": "bus pateikta, kai užsakymas bus pristatytas",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Sukurta NAUJA pretenzija {reference}, nes {planned} uždaryta — redaguokite juodraščio tekstą",
        "NEW_CLAIM": "Sukurta NAUJA pretenzija {reference}, užuot atnaujinus {planned} — redaguokite juodraščio tekstą",
        "OTHER_CLAIM": "Atnaujinta pretenzija {reference}, o ne {planned} — redaguokite juodraščio tekstą",
        "EXISTING_CLAIM": "Nauja pretenzija nesukurta, atnaujinta esama {reference} — redaguokite juodraščio tekstą",
        "OTHER": "Įvyko kitaip, nei numatė juodraštis — redaguokite juodraščio tekstą"
      },
      "FAILED": "Nepavyko",
      "UNREACHABLE": "Nepavyko susisiekti su botu",
      "REQUEST_FAILED": "Nepavyko pradėti veiksmo, bandykite dar kartą.",
      "ACTIONS": {
        "CANCEL_ORDER": "Atšaukite užsakymą",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Pakeiskite apmokėjimą į grynuosius pristatymo metu",
        "CREATE_CLAIM": "Pateikite pretenziją",
        "CREATE_OR_UPDATE_CLAIM": "Pateikite arba atnaujinkite pretenziją",
        "EXTEND_ORDER_PICKUP_DATE": "Pratęskite atsiėmimo terminą"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Įkeliami priedai...",
    "REPLIED_TO_STORY": "Atsakė į tavo pasakojimą",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ši žinutė nepalaikoma. Jūs galite peržiūrėti šią žinutę Facebook Messenger programėlėje.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ši žinutė nepalaikoma. Jūs galite peržiūrėti šią žinutę Instagram programėlėje.",
    "SUCCESS_DELETE_MESSAGE": "Pranešimas ištrintas sėkmingai",
    "FAIL_DELETE_MESSSAGE": "Nepavyko ištrinti pranešimo! Bandykite dar kartą",
    "NO_RESPONSE": "Nėra atsakymo",
    "RESPONSE": "Response",
    "RATING_TITLE": "Reitingas",
    "FEEDBACK_TITLE": "Grįžtamasis ryšys",
    "REPLY_MESSAGE_NOT_FOUND": "Pranešimas nepasiekiamas",
    "CARD": {
      "SHOW_LABELS": "Rodyti etiketes",
      "HIDE_LABELS": "Slėpti etiketes"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Išspręsti",
      "REOPEN_ACTION": "Atidarykite iš naujo",
      "OPEN_ACTION": "Atidaryti",
      "OPEN": "Daugiau",
      "CLOSE": "Uždaryti",
      "DETAILS": "smulkesnė informacija",
      "SNOOZED_UNTIL": "Atidėta iki",
      "SNOOZED_UNTIL_TOMORROW": "Atidėta iki rytojaus",
      "SNOOZED_UNTIL_NEXT_WEEK": "Atidėta iki kitos savaitės",
      "SNOOZED_UNTIL_NEXT_REPLY": "Atidėta iki kito atsakymo",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Pažymėti kaip laukiantį",
      "SNOOZE_UNTIL": "Atidėti",
      "SNOOZE": {
        "TITLE": "Atidėti iki",
        "NEXT_REPLY": "Kitas atsakymas",
        "TOMORROW": "Rytoj",
        "NEXT_WEEK": "Kitą savaitę"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Atidėti iki",
      "APPLY": "Atidėti",
      "CANCEL": "Atšaukti"
    },
    "PRIORITY": {
      "TITLE": "Prioritetas",
      "OPTIONS": {
        "NONE": "Nėra",
        "URGENT": "Skubus",
        "HIGH": "Aukštas",
        "MEDIUM": "Vidutinis",
        "LOW": "Žemas"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nėra",
        "INPUT_PLACEHOLDER": "Pasirinkti prioritetą",
        "NO_RESULTS": "Nieko nerasta",
        "SUCCESSFUL": "Prioritetas pokalbiui id {conversationId} pakeistas į {priority}",
        "FAILED": "Nepavyko pakeisti prioriteto. Prašau, pabandykite dar kartą."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Atidaryti naujame skirtuke",
      "COPY_LINK": "Kopijuoti pokalbio nuorodą",
      "COPY_LINK_SUCCESS": "Pokalbio nuoroda nukopijuota į iškarpinę",
      "PENDING": "Pažymėti kaip laukiantį",
      "RESOLVED": "Pažymėti kaip išspręstą",
      "MARK_AS_UNREAD": "Pažymėti kaip neperskaitytą",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Atidaryti pokalbį",
      "SNOOZE": {
        "TITLE": "Atidėti",
        "NEXT_REPLY": "Iki kito atsakymo",
        "TOMORROW": "Iki rytojaus",
        "NEXT_WEEK": "Iki kitos savaitės"
      },
      "ASSIGN_AGENT": "Priskirti Agentą",
      "ASSIGN_LABEL": "Priskirti etiketę",
      "AGENTS_LOADING": "Agentai užkraunami...",
      "ASSIGN_TEAM": "Priskirti komandą",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Pokalbis id {conversationId} priskirtas \"{agentName}\"",
          "FAILED": "Nepavyko priskirti agento. Prašau, pabandykite dar kartą."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nepavyko priskirti etiketės. Prašau, pabandykite dar kartą."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Priskirta komanda #{team} pokalbiui id {conversationId}",
          "FAILED": "Nepavyko priskirti komandos. Prašau, pabandykite dar kartą."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Pranešimo parašas",
      "ENABLE_SIGN_TOOLTIP": "Įjungti parašą",
      "DISABLE_SIGN_TOOLTIP": "Išjungti parašą",
      "MSG_INPUT": "Spauksite Shift + Enter, pradėjimui iš naujos eilutės. Pradėkite nuo „/“, kad pasirinktumėte Atsakymo Ruošinį.",
      "PRIVATE_MSG_INPUT": "Spauksite Shift + Enter, pradėjimui iš naujos eilutės. Tai bus matoma tik Agentams",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Pranešimo parašas nesukonfigūruotas, sukonfigūruokite jį profilio nustatymuose.",
      "CLICK_HERE": "Spausti čia kad atnaujinti",
      "WHATSAPP_TEMPLATES": "Whatsapp Šablonai",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24 valandų WhatsApp laikotarpis baigėsi. Atsakykite šablono žinute.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Atrodo, kad jūsų atsakymas yra {draftLanguage} kalba, bet šis pokalbis yra {conversationLanguage} kalba.",
      "TRANSLATE_DRAFT": "Versti",
      "REPLY": "Atsakyti",
      "PRIVATE_NOTE": "Privati pastaba",
      "SEND": "Siųsti",
      "CREATE": "Pridėti pastabą",
      "INSERT_READ_MORE": "Skaityti daugiau",
      "DISMISS_REPLY": "Atšaukti atsakymą",
      "REPLYING_TO": "Atsakant į:",
      "TIP_FORMAT_ICON": "Rodyti raiškiojo teksto redagavimo priemonę",
      "HEADING_LEVEL": {
        "LABEL": "Teksto stilius",
        "NORMAL": "Paprastas tekstas",
        "H1": "1 lygio antraštė",
        "H2": "2 lygio antraštė",
        "H3": "3 lygio antraštė"
      },
      "EDITOR": {
        "BOLD": "Pusjuodis",
        "ITALIC": "Kursyvas",
        "UNDERLINE": "Pabrauktas",
        "TEXT_COLOR": "Teksto spalva",
        "BG_COLOR_LABEL": "Fono spalva",
        "FONT_SIZE_LABEL": "Šrifto dydis",
        "FONT_SIZE": {
          "XS": "Mažas",
          "SM": "Vidutiniškai mažas",
          "MD": "Numatytasis",
          "LG": "Didelis",
          "XL": "Labai didelis",
          "XXL": "Milžiniškas"
        },
        "CODE": "Kodas",
        "LINK": "Pridėti arba pašalinti nuorodą",
        "CREATE_LINK": "Sukurti nuorodą",
        "SAVE_LINK": "Išsaugoti",
        "CANCEL": "Atšaukti",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Anuliuoti",
        "REDO": "Grąžinti",
        "BULLET_LIST": "Sąrašas su ženkleliais",
        "ORDERED_LIST": "Numeruotas sąrašas",
        "BLOCKQUOTE": "Citata",
        "H1": "Antraštė 1",
        "H2": "Antraštė 2",
        "H3": "Antraštė 3",
        "IMAGE_UPLOAD": "Įkelti paveikslėlį",
        "CLEAR_FORMATTING": "Išvalyti formatavimą",
        "COLOR": {
          "RED": "Raudona",
          "YELLOW": "Geltona",
          "BLUE": "Mėlyna",
          "ROSE_RED": "Rausvai raudona",
          "DEEP_CYAN": "Tamsiai žydra",
          "ORANGE": "Oranžinė",
          "PISTACHIO": "Pistacijų",
          "PURPLE": "Violetinė",
          "FUCHSIA": "Fuksijų",
          "SILVER": "Sidabrinė",
          "NAVY": "Tamsiai mėlyna",
          "OLD_PINK": "Senoviškai rožinė",
          "AQUA": "Žydra",
          "BROWN": "Ruda",
          "OLIVE": "Alyvuogių",
          "GOLD": "Auksinė",
          "BEIGE": "Smėlio",
          "WINE": "Vyno raudona",
          "FOREST": "Miško žalia",
          "GREEN": "Žalia",
          "BLUE_GREY": "Mėlynai pilka",
          "RUBY_RED": "Rubino raudona",
          "CHESTNUT_BROWN": "Kaštoninė ruda",
          "ASH_GREY": "Pelenų pilka"
        },
        "BG_COLOR": {
          "RED": "Raudona",
          "YELLOW": "Geltona",
          "BLUE": "Mėlyna",
          "ROSE_RED": "Rausvai raudona",
          "DEEP_CYAN": "Tamsiai žydra",
          "ORANGE": "Oranžinė",
          "PISTACHIO": "Pistacijų",
          "PURPLE": "Violetinė",
          "FUCHSIA": "Fuksijų",
          "SILVER": "Sidabrinė",
          "NAVY": "Tamsiai mėlyna",
          "OLD_PINK": "Senoviškai rožinė",
          "AQUA": "Žydra",
          "BROWN": "Ruda",
          "OLIVE": "Alyvuogių",
          "GOLD": "Auksinė",
          "BEIGE": "Smėlio",
          "WINE": "Vyno raudona",
          "FOREST": "Miško žalia",
          "GREEN": "Žalia",
          "BLUE_GREY": "Mėlynai pilka",
          "RUBY_RED": "Rubino raudona",
          "CHESTNUT_BROWN": "Kaštoninė ruda",
          "ASH_GREY": "Pelenų pilka"
        }
      },
      "TIP_EMOJI_ICON": "Parodyti emodžio parinkiklį",
      "TIP_ATTACH_ICON": "Pridėti failus",
      "TIP_AUDIORECORDER_ICON": "Įrašyti audio",
      "TIP_AUDIORECORDER_PERMISSION": "Leisti prieiti prie audio",
      "TIP_AUDIORECORDER_ERROR": "Nepavyko atidaryti audio",
      "DRAG_DROP": "Norėdami pridėti, vilkite ir numeskite čia",
      "START_AUDIO_RECORDING": "Pradėti audio įrašymą",
      "STOP_AUDIO_RECORDING": "Baigti audio įrašymą",
      "": "",
      "EMAIL_HEAD": {
        "TO": "Kam",
        "ADD_BCC": "Pridėti bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "El. laiškai atskirti kableliais",
          "ERROR": "Prašau įveskite teisingą el. pašto adresą"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "El. laiškai atskirti kableliais",
          "ERROR": "Prašau įveskite teisingą el. pašto adresą"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Neapibrėžti kintamieji",
        "MESSAGE": "Jūsų pranešime yra {undefinedVariablesCount} neapibrėžtų kintamųjų: {undefinedVariables}. Ar vis tiek norėtumėte išsiųsti žinutę?",
        "CONFIRM": {
          "YES": "Siųsti",
          "CANCEL": "Atšaukti"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Pridėkite SMS gautųjų laiškų aplanką, kad galėtumėte siųsti SMS atsakymus.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privati ​​pastaba: matoma tik jums ir jūsų komandai",
    "CHANGE_STATUS": "Pokalbio būsena pakeista",
    "CHANGE_STATUS_FAILED": "Pokalbio būsenos nepavyko pakeisti",
    "CHANGE_AGENT": "Pasikeitė pokalbiui priskirtas asmuo",
    "CHANGE_AGENT_FAILED": "Priskirto asmens pakeitimas nepavyko",
    "ASSIGN_LABEL_SUCCESFUL": "Etiketė sėkmingai priskirta",
    "ASSIGN_LABEL_FAILED": "Etiketės priskirti nepavyko",
    "CHANGE_TEAM": "Pasikeitė pokalbių komanda",
    "FILE_SIZE_LIMIT": "Failas viršija {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB priedo apribojimą",
    "MESSAGE_ERROR": "Nepavyko išsiųsti šio pranešimo, bandykite dar kartą vėliau",
    "SENT_BY": "Siuntėjas:",
    "BOT": "Botas",
    "SEND_FAILED": "Nepavyko išsiųsti pranešimo! Bandykite dar kartą",
    "TRY_AGAIN": "kartoti",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Pasirinkti agentą",
      "REMOVE": "Pašalinti",
      "ASSIGN": "Priskirti"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopijuoti",
      "REPLY_TO": "Atsakyti į šią žinutę",
      "DELETE": "Ištrinti",
      "CREATE_A_CANNED_RESPONSE": "Pridėti Atsakymų Ruošinius",
      "TRANSLATE": "Išversti",
      "COPY_PERMALINK": "Nukopijuoti nuorodą į pranešimą",
      "LINK_COPIED": "Pranešimo URL nukopijuotas į iškarpinę",
      "DELETE_CONFIRMATION": {
        "TITLE": "Ar tikrai norite ištrinti šį pranešimą?",
        "MESSAGE": "Negalite anuliuoti šio veiksmo",
        "DELETE": "Ištrinti",
        "CANCEL": "Atšaukti"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Kontaktas",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Pokalbį pažymėjo {userName} kaip baigtą",
          "CONTACT_RESOLVED": "Pokalbį užbaigė {contactName}",
          "OPEN": "Pokalbį iš naujo pradėjo {userName}",
          "PENDING": "Pokalbį pažymėjo {userName} kaip laukiantį",
          "SNOOZED": "Pokalbį atidėjo {userName}",
          "AUTO_RESOLVED": "Sistema pokalbį pažymėjo kaip baigtą dėl {duration} neaktyvumo dienų",
          "SYSTEM_AUTO_OPEN": "Sistema vėl atidarė pokalbį dėl naujo gaunamo pranešimo.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Sistema išsprendė pokalbį, nes užklausa buvo uždaryta „Kaufland“ platformoje."
        },
        "PRIORITY": {
          "ADDED": "{userName} nustatė prioritetą į {newPriority}",
          "UPDATED": "{userName} pakeitė prioritetą iš {oldPriority} į {newPriority}",
          "REMOVED": "{userName} pašalino prioritetą"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} sau priskyrė šį pokalbį",
          "ASSIGNED": "{userName} priskyrė {assigneeName}",
          "REMOVED": "{userName} atšaukė pokalbio priskyrimą"
        },
        "TEAM": {
          "ASSIGNED": "{userName} priskyrė {teamName}",
          "ASSIGNED_WITH_ASSIGNEE": "{userName} priskyrė {assigneeName} per {teamName}",
          "REMOVED": "{userName} atšauktas iš {teamName}"
        },
        "LABELS": {
          "ADDED": "{userName} pridėjo {labels}",
          "REMOVED": "{userName} pašalino {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} nutildė pokalbį",
        "UNMUTED": "{userName} įjungė pokalbio garsą",
        "CONTACT_BLOCKED": "{userName} užblokavo kontaktą",
        "CONTACT_UNBLOCKED": "{userName} atblokavo kontaktą",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Perkelta, nes kontakto užsakymai yra tik iš parduotuvės {storeName} (paskutinis užsakymas {orderId}), kurios robotas atsako šioje pašto dėžutėje.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatizavimas praleistas, nes kontaktas užblokuotas",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizacija „{ruleName}“ negalėjo perkelti šio pokalbio iš aplanko {sourceInboxName} į aplanką {targetInboxName}, nes aplankai nesuderinami.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija „{ruleName}“ negalėjo perkelti šio pokalbio iš aplanko {sourceInboxName} į aplanką {targetInboxName}, nes kontaktas neturi el. pašto adreso.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizacija „{ruleName}“ negalėjo išsiųsti pranešimo: šis telefono gautų laiškų aplankas negali siųsti SMS, nes paskyroje nėra SMS gautų laiškų aplanko. Taisyklė išjungta, administratoriai gavo el. laišką.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizacija „{ruleName}“ negalėjo išsiųsti pranešimo: iš šio gautų laiškų aplanko priedų SMS žinute siųsti negalima. Taisyklė išjungta, administratoriai gavo el. laišką.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makrokomanda „{macroName}“ neišsiuntė pranešimo: šis telefono gautų laiškų aplankas negali siųsti SMS, nes paskyroje nėra SMS gautų laiškų aplanko.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makrokomanda „{macroName}“ neišsiuntė pranešimo: iš šio gautų laiškų aplanko priedų SMS žinute siųsti negalima.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makrokomanda „{macroName}“ neišsiuntė pranešimo: šį pokalbį tvarko botas. Pirmiausia atidarykite pokalbį.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makrokomanda „{macroName}“ neišsiuntė pranešimo: šis gautų laiškų aplankas pažymėtas ištrynimui. Pirmiausia perkelkite pokalbį į kitą gautų laiškų aplanką.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizacija „{ruleName}“ išsiuntė el. laišką adresu {contactEmail} naujame pokalbyje [#{conversationId}]({conversationPath}) aplanke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizacija „{ruleName}“ pradėjo šį pokalbį dėl pokalbio [#{conversationId}]({conversationPath}) aplanke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija „{ruleName}“ negalėjo išsiųsti pranešimo naujame pokalbyje aplanke {inboxName}, nes kontaktas neturi el. pašto adreso.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizacija „{ruleName}“ išsiuntė SMS numeriu {contactPhone} naujame pokalbyje [#{conversationId}]({conversationPath}) aplanke {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizacija „{ruleName}“ negalėjo išsiųsti SMS naujame pokalbyje aplanke {inboxName}, nes kontaktas neturi telefono numerio.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agentas",
            "CUSTOMER": "Klientas"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "atsiliepta kitur, skambėjo {duration}",
            "NO_ANSWER": "neatsiliepta, skambėjo {duration}",
            "REJECTED": "atmesta, skambėjo {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatiškai išspręsta po nesėkmingų atgalinių skambučių: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Skambučio įrašas ištrintas: {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Nematoma klientui",
    "SENT_VIA_EMAIL": "Kontaktui išsiųsta ir el. paštu ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Šis gautų laiškų aplankas pažymėtas ištrynimui, todėl kliento atsakymas niekada nepasiektų. Norėdami atsakyti, perkelkite pokalbį į kitą gautų laiškų aplanką.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Šis kontaktas turi kitą atvirą pokalbį #{id}",
      "MULTIPLE": "Šis kontaktas turi kitų atvirų pokalbių ({count})",
      "OPEN": "Atidaryti",
      "SHOW": "Rodyti"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Paprašyti kliento pasidalyti savo WhatsApp telefono numeriu",
      "PENDING_ACTION": "Kontakto informacijos užklausa laukia atsakymo",
      "STATES": {
        "PENDING": "Laukiama kontakto informacijos",
        "SHARED": "Telefono numeriu pasidalyta",
        "IDENTITY_CONFLICT": "Telefono numerį reikia peržiūrėti"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Siųsti poklabio stenogramą",
    "DESC": "Siųsti pokalbio stenogramos kopiją nurodytu el. pašto adresu",
    "SUBMIT": "Pateikti",
    "CANCEL": "Atšaukti",
    "SEND_EMAIL_SUCCESS": "Pokalbio stenograma sėkmingai išsiųsta",
    "SEND_EMAIL_ERROR": "Įvyko klaida, prašau pabandykite dar kartą",
    "FORM": {
      "SEND_TO_CONTACT": "Siųsti stenogramą klientui",
      "SEND_TO_AGENT": "Siųsti stenogramą priskirtam agentui",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Siųsti stenogramą kitu el. pašto adresu",
      "EMAIL": {
        "PLACEHOLDER": "Įvesti el. pašto adresą",
        "ERROR": "Prašau įveskite teisingą el. pašto adresą"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Sveiki 👋, Sveiki atvykę į {installationName}!",
    "DESCRIPTION": "Ačiū, kad užsiregistravote. Norime, kad išnaudotumėte visas {installationName} galimybes. Štai keletas dalykų, kuriuos galite padaryti naudodami {installationName}, kad patirtis būtų maloni.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Skaitykite mūsų naujausius atnaujinimus",
    "ALL_CONVERSATION": {
      "TITLE": "Visi jūsų pokalbiai vienoje vietoje",
      "DESCRIPTION": "Peržiūrėkite visus savo klientų pokalbius vienoje informacijos suvestinėje. Galite filtruoti pokalbius pagal gaunamą kanalą, etiketę ir būseną.",
      "NEW_LINK": "Spustelėkite čia, kad sukurtumėte gautų laiškų aplanką"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pakvieskite savo komandos narius",
      "DESCRIPTION": "Kadangi ruošiatės kalbėtis su savo klientu, pasikvieskite savo komandos draugus, kad jie jums padėtų. Galite pakviesti savo komandos draugus įtraukę jų el. pašto adresus į agentų sąrašą.",
      "NEW_LINK": "Spustelėkite čia, kad pakviestumėte komandos narį"
    },
    "LABELS": {
      "TITLE": "Tvarkykite pokalbius etiketėmis",
      "DESCRIPTION": "Etiketės suteikia lengvesnį būdą suskirstyti pokalbį į kategorijas. Sukurkite keletą etikečių, pvz., #palaikymo-klausimas, #atsiskaitymo-klausimas ir kt., kad vėliau galėtumėte jas naudoti pokalbyje.",
      "NEW_LINK": "Spustelėkite čia, kad sukurtumėte žymas"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Priskirtas Agentas",
    "SELF_ASSIGN": "Priskirti man",
    "TEAM_LABEL": "Priskirta komanda",
    "SELECT": {
      "PLACEHOLDER": "Nėra"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Kontakto detali informacija",
      "CONVERSATION_ACTIONS": "Pokalbio veiksmai",
      "CONVERSATION_LABELS": "Pokalbio Etiketės",
      "CONVERSATION_INFO": "Pokalbio Informacija",
      "CONTACT_ATTRIBUTES": "Kontakto Požymiai",
      "PREVIOUS_CONVERSATION": "Ankstesni pokalbiai",
      "MACROS": "Makrokomandos",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Laukiama",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Sukurti požymį",
    "NO_RECORDS_FOUND": "Požymių nerasta",
    "UPDATE": {
      "SUCCESS": "Požymis atnaujintas sėkmingai",
      "ERROR": "Nepavyko atnaujinti požymio. Pabandykite dar kartą vėliau"
    },
    "ADD": {
      "TITLE": "Pridėti",
      "SUCCESS": "Požymis pridėtas sėkmingai",
      "ERROR": "Nepavyko pridėti požymį. Pabandykite dar kartą vėliau"
    },
    "DELETE": {
      "SUCCESS": "Požymis ištrintas sėkmingai",
      "ERROR": "Nepavyko ištrinti požymio. Pabandykite dar kartą vėliau"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Pridėti požymius",
      "PLACEHOLDER": "Ieškoti požymių",
      "NO_RESULT": "Požymių nerasta"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Nuo",
    "TO": "Kam",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Tema"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Dalyvaujantys",
    "SIDEBAR_TITLE": "Pokalbio dalyviai",
    "NO_RECORDS_FOUND": "Nieko nerasta",
    "ADD_PARTICIPANTS": "Pasirinkti dalyvius",
    "REMANING_PARTICIPANTS_TEXT": "+{count} kiti",
    "REMANING_PARTICIPANT_TEXT": "+{count} kitas",
    "TOTAL_PARTICIPANTS_TEXT": "{count} dalyvauja žmonių.",
    "TOTAL_PARTICIPANT_TEXT": "{count} dalyvauja asmenų.",
    "NO_PARTICIPANTS_TEXT": "Niekas nedalyvauja!.",
    "WATCH_CONVERSATION": "Prisijungti pire pokalbio",
    "YOU_ARE_WATCHING": "Jūs dalyvaujate",
    "API": {
      "ERROR_MESSAGE": "Nepavyko atnaujinti, bandykite dar kartą!",
      "SUCCESS_MESSAGE": "Dalyviai atnaujinti!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Rodyti išverstą turinį",
    "DESC": "Galite peržiūrėti išverstą turinį kiekviena kalba.",
    "ORIGINAL_CONTENT": "Originalus turinys",
    "TRANSLATED_CONTENT": "Išverstas turinys",
    "NO_TRANSLATIONS_AVAILABLE": "Nėra šio turinio vertimo"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Užsakymo numeris",
    "EXTERNAL_ID": "Išorinis ID",
    "PAYMENT_TYPE": "Mokėjimo būdas",
    "PAYMENT_DATE": "Mokėjimo data",
    "DELIVERY_PROVIDER": "Vežėjas",
    "EXPECTED_DATE_OF_DELIVERY": "Numatomas pristatymas",
    "DATE_OF_DELIVERY": "Pristatyta",
    "EXPEDITION_DATE": "Išsiuntimo data",
    "INTERNAL_NOTE": "Parduotuvės pastaba",
    "PACKAGE_NUMBER": "Siunta"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
